import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  FormControlLabel,
  Checkbox,
  Typography,
  Paper,
} from '@mui/material';
import {
  MODULE_ACCESS,
  MODULE_ACCESS_OPERATIONS,
} from '../../config/module-access.config';
import Loading from '../table-elements/loading.component';

const ModuleAccess = ({ defaultValue, onChange }) => {
  const [modules, setModules] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initialModules = {};
    Object.values(MODULE_ACCESS).forEach((module) => {
      module.rows.forEach((r) => {
        initialModules[r.value] = [];
      });
    });

    if (defaultValue) {
      setModules({ ...initialModules, ...defaultValue });
    } else {
      setModules(initialModules);
    }
    setLoading(false);
  }, [defaultValue]);

  const handleCheckboxChange = (moduleName, accessType) => (event) => {
    const updatedModules = {
      ...modules,
      [moduleName]: event.target.checked
        ? [...modules[moduleName], accessType]
        : modules[moduleName].filter((type) => type !== accessType),
    };

    setModules(updatedModules);
    onChange(updatedModules);
  };

  return (
    <>
      {loading && <Loading />}

      {!loading && (
        <Paper elevation={3} sx={{ padding: 2 }}>
          <Grid container alignItems="center">
            <Grid item xs={3}>
              <Typography variant="h6" gutterBottom>
                Manage Access
              </Typography>
            </Grid>
            <Grid
              container
              item
              xs={9}
              direction="row"
              justifyContent="flex-end"
            >
              {Object.keys(MODULE_ACCESS_OPERATIONS).map((ops) => (
                <Grid item xs={2} key={ops}>
                  <Typography variant="subtitle1">
                    {MODULE_ACCESS_OPERATIONS[ops]}
                  </Typography>
                </Grid>
              ))}
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            {Object.keys(MODULE_ACCESS).map((moduleName) => (
              <Grid
                item
                xs={12}
                justifyContent="space-between"
                key={moduleName}
              >
                <Grid item xs={3}>
                  <Typography variant="subtitle1">
                    {MODULE_ACCESS[moduleName].label}
                  </Typography>
                </Grid>

                <Paper
                  elevation={1}
                  sx={{ paddingInline: 1, backgroundColor: '#919eab1f' }}
                >
                  {MODULE_ACCESS[moduleName].rows.map((mr) => (
                    <Grid container alignItems="center">
                      <Grid item xs={3}>
                        <Typography variant="caption">{mr.label}</Typography>
                      </Grid>
                      <Grid
                        container
                        item
                        xs={9}
                        direction="row"
                        justifyContent="flex-end"
                      >
                        {Object.keys(MODULE_ACCESS_OPERATIONS).map((ops) =>
                          mr.access?.includes(ops) ? (
                            <Grid item xs={2} key={ops}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={modules[mr.value]?.includes(ops)}
                                    onChange={handleCheckboxChange(
                                      mr.value,
                                      ops
                                    )}
                                  />
                                }
                              />
                            </Grid>
                          ) : (
                            <Grid item xs={2} key={ops} />
                          )
                        )}
                      </Grid>
                    </Grid>
                  ))}
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Paper>
      )}
    </>
  );
};

ModuleAccess.propTypes = {
  defaultValue: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
  onChange: PropTypes.func.isRequired,
};

ModuleAccess.defaultProps = {
  defaultValue: {},
};

export default ModuleAccess;
